// US-style date formatter. Storage stays ISO (YYYY-MM-DD) so dates sort
// correctly; display is "MM/DD/YYYY" for US locale.
export const formatUS = (iso) => {
  if (!iso || typeof iso !== "string") return "";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[2]}/${m[3]}/${m[1]}`;
};
